import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import css from '../css/module/insights.css';
import { safeOnClick } from '../util/helpers/event-helpers';
import ElementWithToolTip from './ElementWithToolTip';

class CategoriesLinkIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
    this.value = React.createRef();
    this.copyValue = this.copyValue.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this._timer);
  }

  copyValue() {
    try {
      this.value.current.select();
      const successful = document.execCommand('copy');
      if (successful) {
        this.setState({
          copied: true,
        });
        this._timer = setTimeout(() => {
          this.setState({
            copied: false,
          });
        }, 3000);
      }
    } catch (err) {
      alert(err);
    }
  }

  render() {
    const { path, index } = this.props;
    const { copied } = this.state;

    // need to update the key so that the it rebuilds the tooltip and prevents it shifting positions based on the size of the text
    const key = `${index}_${copied}`;

    return (
      <ElementWithToolTip key={key} text={copied ? 'Copied!' : 'Copy link'}>
        <div
          className={`${css.boxControl} position-relative ${css.tagButton}`}
          style={{ fontSize: '0.8em' }}
          onClick={safeOnClick(this.copyValue)}
        >
          <FontAwesomeIcon icon="link" />
          <textarea
            type="text"
            style={{
              width: '5px',
              height: '5px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              zIndex: -1,
            }}
            value={path}
            readOnly
            ref={this.value}
          />
        </div>
      </ElementWithToolTip>
    );
  }
}

export default CategoriesLinkIcon;
